import { render, staticRenderFns } from "./BehaviorForm.vue?vue&type=template&id=4b8d012c&scoped=true&"
import script from "./BehaviorForm.vue?vue&type=script&lang=js&"
export * from "./BehaviorForm.vue?vue&type=script&lang=js&"
import style0 from "./BehaviorForm.vue?vue&type=style&index=0&id=4b8d012c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8d012c",
  null
  
)

export default component.exports